<template>
  <ModelEditFormPriceAgreement
    class="model-edit-form-project-rental-intake-item"
    v-model="priceAgreement"
    :is-retrieving="isRetrieving"
    :project="project"
    variant="project"
    @input="wasChanged = true"
  />
</template>

<script setup lang="ts">
import ModelEditFormPriceAgreement from "@/components/model_edit_form/ModelEditFormPriceAgreement.vue"
import { Project } from "@/models/project.model"
import { useModelEditFormPriceAgreementManager } from "@/composables/administration/model-edit-form-project-price-agreement-manager"
import { inject } from "vue"
import type { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { ProjectRentalIntakeItem } from "@/models/project-rental-intake-item.model"
import { useProjectsRentalIntakeItemsStore } from "@/store/projects-rental-intake-items.store"

const props = defineProps<{
  project: Project
  rentalIntakeItem: RentalIntakeItem
}>()

const { priceAgreement, savePriceAgreement, isRetrieving, wasChanged } =
  useModelEditFormPriceAgreementManager<RentalIntakeItem, ProjectRentalIntakeItem>(
    props.project,
    props.rentalIntakeItem,
    useProjectsRentalIntakeItemsStore(),
    inject("projectRentalIntakeItemController")!,
    ProjectRentalIntakeItem
  )

defineExpose({ savePriceAgreement })
</script>

<style scoped></style>
